import React from "react";
import profileBanner from "../../../assets/icons/profileBanner.jpeg";
import ProfileForm from "../ProfileForm/ProfileForm";
import "./ProfileHome.scss";
import GlobalStore from "../../store/globalStore";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { DropOffLogAPI } from "../../Services/dashboard/docVerificationAPIServices";
import NonIndividualProfile from "../ProfileForm/NonIndividualProfile";

export interface ProfileHomeProps { }

const ProfileHome: React.FC<ProfileHomeProps> = (props) => {
  const dropOffObj = () => {
    let userId = 0;
    //  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    const stageInfoObj = {
      applicationid: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : GlobalStore?.accountcategory,
      stageOrderId: 14,
      userId: userId?.toString(),
      rmAssisted: GlobalStore?.stageStatus?.rmassisted,
    };
    DropOffLogAPI(() => { }, stageInfoObj);
  };
  React.useEffect(() => {
    dropOffObj();
    window.sessionStorage.setItem("stageInfoId", "1");
  }, []);

  return (
    <div className="prflHome">
      <div className="prflHeading">
        <label>Profile</label>
      </div>
      <div className="banner">
        <img className="bannerImg" src={profileBanner} alt="Profile" />
      </div>
      {
        GlobalStore.entityType == "NONINDIVIDUAL" ?
          <NonIndividualProfile />
          :
          <ProfileForm />
      }
    </div>
  );
};

export default ProfileHome;
